import { z } from 'zod';

import { Option } from '../../types/Option';

export type ProtectionDirection = 'unidirectional' | 'bidirectional';

const options = [
    { value: 'unidirectional', label: 'Unidirectional (uP)' },
    { value: 'bidirectional', label: 'Bidirectional (bP)' },
] as Option<ProtectionDirection>[];

const validator = z.enum(['unidirectional', 'bidirectional']).nullable().default(null);

export const ProtectionDirection = {
    validator,
    options,
};
